export const formatPercentage = (value: string | null) => {
    if (!value) return "TBA";

    const num = Number(value);
    if (Number.isNaN(num)) return "TBA";

    return `${Math.round(num)}%`;
};